<template>
  <SntSelect
    :width="width"
    :value="value"
    :items="filteredItems"
    :loading="$apollo.loading"
    :has-next-page="stocks.hasNextPage"
    :callback="fetchMore"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :item-value="itemValue"
    :hide-details="hideDetails"
    item-text="name"
    @input="$emit('input', $event)" />
</template>

<script>
import { GET_STOCKS } from '@/resources/graphql'
import SntSelect from '@/components/form/SntSelect.vue'

export default {
  components: {
    SntSelect
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'ทั้งหมด'
    },
    width: {
      type: String,
      default: '374px'
    },
    ignoreValues: {
      type: Array,
      default: () => ([])
    },
    hideDetails: Boolean,
    defaultFirstValue: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    nullable: Boolean
  },
  apollo: {
    stocks: {
      query: GET_STOCKS,
      variables () {
        return {
          page: 1,
          perPage: this.perPage,
          orderBy: 'id_ASC'
        }
      },
      update ({ stocks }) {
        if (this.nullable) {
          return {
            ...stocks,
            nodes: this.$_.concat([{
              id: null,
              isMain: false,
              name: 'ทั้งหมด'
            }], stocks.nodes)
          }
        }
        return stocks
      },
      result ({ data }) {
        this.onLoaded(data)
        this.selectDefaultFirstValue()
      }
    }
  },
  data () {
    return {
      page: 1,
      perPage: 20,
      itemValue: 'id',
      stocks: {
        nodes: [],
        hasNextPage: false
      }
    }
  },
  computed: {
    filteredItems () {
      let items = this.stocks.nodes
      if (this.ignoreValues?.length) {
        items = items.filter((item) => !this.ignoreValues?.includes(item[this.itemValue]))
      }
      return items
    }
  },
  watch: {
    ignoreValues () {
      this.selectDefaultFirstValue()
    }
  },
  methods: {
    fetchMore () {
      this.page += 1
      return this.$apollo.queries.stocks.fetchMore({
        variables: {
          page: this.page,
          perPage: this.perPage
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const { hasNextPage, nodes } = fetchMoreResult.stocks
          return ({
            stocks: {
              __typename: previousResult.stocks.__typename,
              nodes: this.$_.uniqBy([
                ...previousResult.stocks.nodes,
                ...nodes
              ], this.itemValue),
              hasNextPage
            }
          })
        }
      })
    },
    selectDefaultFirstValue () {
      if (this.defaultFirstValue && !this.value) {
        const item = this.$_.head(this.filteredItems)
        if (item) {
          this.$emit('input', item[this.itemValue])
        }
      }
    },
    onLoaded (data) {
      this.$emit('loaded', data)
    }
  }
}
</script>
